import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import { useDispatch, useSelector } from "react-redux";
import { snackRemoved } from "src/slices/system";
import { selectSnacks } from "./selectors";

type Props = {};

const SnackbarProvider = (props: Props) => {
  const snacks = useSelector(selectSnacks);
  const dispatch = useDispatch();

  const handleClose = (id: string) => {
    dispatch(snackRemoved(id));
  };
  return (
    <>
      {snacks.map((snack) => (
        <Snackbar
          key={snack.id}
          open={true}
          autoHideDuration={snack.duration ?? 10000}
          onClose={() => handleClose(snack.id)}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert
            severity={snack.type}
            sx={{ width: "100%" }}
            onClose={() => handleClose(snack.id)}
          >
            {snack.message}
          </Alert>
        </Snackbar>
      ))}
    </>
  );
};

export default SnackbarProvider;
